import { useSEO } from "../lib/seo";
import { COMPANY } from "../data/content";

const PrivacyPage = () => {
  useSEO("Politique de confidentialité — BÂTI 360", "Politique de confidentialité et gestion des données personnelles sur le site BÂTI 360.");
  return (
    <div className="bg-white pb-24 pt-40">
      <div className="mx-auto max-w-3xl px-5">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink">Politique de confidentialité</h1>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Données collectées</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Lorsque vous utilisez notre formulaire de demande de devis, nous collectons les informations nécessaires à l'étude de votre projet : identité, coordonnées (téléphone, e-mail), adresse du chantier, caractéristiques du projet (type, surface, budget, description) ainsi que les photographies et plans que vous nous transmettez volontairement.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Finalité du traitement</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Ces données sont utilisées exclusivement pour répondre à votre demande, étudier votre projet et vous recontacter. Elles ne font l'objet d'aucune prospection commerciale et ne sont ni vendues ni transmises à des tiers.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Durée de conservation</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Les demandes de devis sont conservées pendant la durée nécessaire au traitement de votre projet, puis archivées ou supprimées au plus tard 3 ans après notre dernier échange.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Cookies</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Ce site utilise des cookies de mesure d'audience, soumis à votre consentement. Vous pouvez accepter ou refuser leur dépôt via le bandeau affiché lors de votre première visite, et modifier votre choix en supprimant les données du site dans votre navigateur.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Vos droits</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données. Pour exercer ces droits, écrivez-nous à {COMPANY.email} ou par courrier : {COMPANY.name}, {COMPANY.address}, {COMPANY.city}. Vous pouvez également saisir la CNIL en cas de litige.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
